import { countryList } from "../../src/constants"; 
import { Countries } from "../types";
import { Country } from "../types";

/**
 * @param Countries - The extracted list of available countries.
 * @returns An array of Country objects available for the "Mobile Money" payment method.
 */
export const getAvailableCountries = (
    Countries: Countries[] | undefined,
): Country[] => {
  
    const uniqueCountryMap = new Map<string, Countries>();

    Countries?.forEach((country) => {
        if (!uniqueCountryMap.has(country.countryCode)) {
            uniqueCountryMap.set(country.countryCode, country);
        }
    });

  const availableCountryCodes: Set<string> = new Set(
   uniqueCountryMap.keys()
  );

  const filteredCountryList = countryList.filter((country) =>
    availableCountryCodes.has(country.code)
  );

  return filteredCountryList;
};

